import { render } from "./field_boolean.vue?vue&type=template&id=1f85b920"
import script from "./field_boolean.vue?vue&type=script&lang=js"
export * from "./field_boolean.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__